import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	fetchedReturns: [],
};

const inboundPurchaseOrdersSlice = createSlice({
	name: 'inboundPO',
	initialState: initialState,
	reducers: {
		setInboundPO: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setInboundPO, reset } = inboundPurchaseOrdersSlice.actions;

export default inboundPurchaseOrdersSlice.reducer;